(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const Quill = require('quill');
    const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

    function escapeSpecialChars(jsonString) {
        return jsonString.replace(/\n/g, "\\n")
            .replace(/\r/g, "\\r")
            .replace(/\t/g, "\\t")
            .replace(/\f/g, "\\f");
    }

    function removeFormating(jsonString) {
        return jsonString.replace(/\n/g, " ")
            .replace(/\r/g, " ")
            .replace(/\t/g, " ")
            .replace(/\f/g, " ")
            .replace(/<br\s*\/?>/g, " ");
    }

    function uniqueId() {
        let length = 8;
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
        let str = '';

        if (!length) {
            length = Math.floor(Math.random() * chars.length);
        }

        for (let i = 0; i < length; i++) {
            str += chars[Math.floor(Math.random() * chars.length)];
        }

        return str;
    }

    class QuillViewModel {
        constructor(params) {
            this.value = params.value;
            this.edit = params.edit;
            this.inline = params.inline;
            this.id = uniqueId();

            if (this.edit) {
                window.setTimeout(() => {
                    let quillInstance = new Quill('#' + this.id, {
                        modules: {
                            toolbar: [
                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                [{'header': 1}, {'header': 2}, {'color': []}, {'background': []}],
                                [{'list': 'ordered'}, {'list': 'bullet'}],
                                [{'indent': '-1'}, {'indent': '+1'}, {'align': []}],
                                ['clean']
                            ]
                        },
                        theme: 'snow'
                    });
                    quillInstance.on('editor-change', () => {
                        this.value(JSON.stringify(quillInstance.getContents()));
                    });
                    quillInstance.setContents(JSON.parse(escapeSpecialChars(this.value())));
                    this.value.subscribe(value => {
                        if (typeof value !== "string" && value.replace) {
                            quillInstance.setContents(JSON.parse(escapeSpecialChars(value.value)));
                        }
                    });
                }, 0);
            } else {
                window.setTimeout(() => {
                    let value = JSON.parse(escapeSpecialChars(ko.unwrap(this.value)));

                    if (this.inline && value.ops) {
                        let newOps = [];
                        value.ops.forEach(op => {
                            if (op.hasOwnProperty('attributes')) {
                                delete op.attributes;
                            }

                            newOps.push(op);
                        });
                        value.ops = newOps;
                    }

                    let quillConverter = new QuillDeltaToHtmlConverter(value.ops, {});
                    let html = quillConverter.convert();

                    if (this.inline) {
                        html = removeFormating(html);
                    }

                    $('#' + this.id).html(html);
                }, 0);
            }
        }
    }

    ko.components.register('quill', {
        viewModel: QuillViewModel,
        template: '<div class="quill" data-bind="attr: { id: id }, css: { \'ql-inline\': inline }"></div>'
    });
})();


// WEBPACK FOOTER //
// ./resources/scripts/components/ko.quill.js